// extracted by mini-css-extract-plugin
export var paginationBullet = "index-module--pagination-bullet--ac854";
export var paginationBulletActive = "index-module--pagination-bullet-active--5e8c1";
export var paginationHorizontal = "index-module--pagination-horizontal--e52b8";
export var paginationVertical = "index-module--pagination-vertical--0eb87";
export var swiperContainer = "index-module--swiper-container--44e10";